export default __webpack_public_path__ + "static/media/feature_username.38403a3f.svg";